import { Link } from "react-router-dom";

const Step3 = () => {
  return (
    <>
      <section>
        <div className="container">
          <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
            {/* Left Container */}
            <div className="flex flex-col items-start justify-start">
              <h1 className="herotitle">Skarvo</h1>
              <p className="text-xl font-normal">Password successfully reset.</p>
            </div>

            {/* Right Container */}
            <div className="flex flex-col gap-10">
              <div className="flex flex-col items-start formcard">
                <div className="flex flex-row items-start formheader">
                  <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Password Reset</div>
                </div>
                <div className="px-[50px] flex space-x-[10x] w-full justify-center mb-[50px]">
                  <img src="/images/success.png" width={80} height={80}></img>
                </div>
                <div className="thickseparator"></div>
                <div className="flex justify-center w-full px-[30px] my-[30px]">
                  <Link to="/signin" className="w-button herobuttonprimary !mb-[0px]">
                    Done
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step3;
